(() => {
  'use strict';
  function setupHeader(scope) {
    const header = scope.querySelector('[data-ms-header]');
    if (!header || header.dataset.msReady) return;
    header.dataset.msReady = 'true';
    const toggle = header.querySelector('[data-ms-menu-toggle]');
    const submenus = [...header.querySelectorAll('[data-ms-submenu]')];
    if (!toggle) return;
    header.classList.add('ms-navigation-ready');
    const closeMenu = () => {
      toggle.setAttribute('aria-expanded', 'false');
      header.classList.remove('ms-menu-open');
      submenus.forEach(item => { item.open = false; });
    };
    const searchController = header.querySelector('[data-ms-search-controller]');
    const searchInput = header.querySelector('.ms-header-search input');
    const openSearch = event => {
      if (!searchController || typeof searchController.openSearchPopup !== 'function') return;
      event.preventDefault();
      closeMenu();
      const popupInput = document.querySelector('[data-search-popup] [data-search-input]');
      if (popupInput && searchInput && event.type !== 'click') {
        popupInput.value = searchInput.value;
        popupInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      searchController.openSearchPopup();
      if (popupInput) popupInput.focus();
    };
    if (searchInput) searchInput.addEventListener('focus', openSearch);
    const searchForm = header.querySelector('.ms-header-search');
    if (searchForm) searchForm.addEventListener('submit', openSearch);
    const mobileSearch = header.querySelector('.ms-mobile-search');
    if (mobileSearch) mobileSearch.addEventListener('click', openSearch);
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      header.classList.toggle('ms-menu-open', open);
    });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const openSubmenu = submenus.find(item => item.open && item.contains(document.activeElement));
      if (openSubmenu) {
        openSubmenu.open = false;
        openSubmenu.querySelector('summary').focus();
      } else if (header.classList.contains('ms-menu-open')) {
        closeMenu();
        toggle.focus();
      }
    });
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) closeMenu();
    });
    submenus.forEach(item => item.addEventListener('toggle', () => {
      if (item.open) submenus.filter(other => other !== item).forEach(other => { other.open = false; });
    }));
    window.matchMedia('(min-width: 1000px)').addEventListener('change', closeMenu);
  }
  let cartRequest = null;
  let cartAgain = false;
  function syncCartCount() {
    if (cartRequest) { cartAgain = true; return cartRequest; }
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    cartRequest = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(response => response.ok ? response.json() : null)
      .then(cart => {
        if (!cart || !Number.isInteger(cart.item_count)) return;
        document.querySelectorAll('[data-ms-cart-count]').forEach(badge => {
          badge.textContent = String(cart.item_count);
          badge.setAttribute('aria-label', (badge.dataset.msCountLabel || '__COUNT__').replace('__COUNT__', String(cart.item_count)));
        });
      }).catch(() => {}).finally(() => {
        cartRequest = null;
        if (cartAgain) { cartAgain = false; syncCartCount(); }
      });
    return cartRequest;
  }
  function init() {
    setupHeader(document);
    if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function' && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, syncCartCount);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => setupHeader(event.target));
  window.addEventListener('pageshow', syncCartCount);
})();
